import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { isAuthenticated } from 'utils/auth';

/**
 * Route guard that redirects to the login page when not authenticated.
 */
const RequireAuth = () => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
};

export default RequireAuth;
